import React, { useState } from 'react'
import Header from '../../components/Header'
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import moment from "moment";
import HtmlToPdf from '../../components/HtmlToPdf';

const SixPeriodEmployee = () => {

  const [checked, setChecked] = useState(false);

  return (
    <>
      <Header logo="sixperiod" />
      <div className="">
        <div className='grid grid-cols-1 md:grid-cols-6 gap-4'>
          <div className='col-span-4'>
            <div className='mx-auto max-w-2xl'>
              <div className="lg:flex lg:items-center py-5 lg:justify-between">
                <div className="min-w-0 flex-1">
                  <h6 className="flex items-center text-2xl font-semibold leading-7 text-gray-600 sm:truncate  sm:tracking-tight">
                    Employee 9807 Amod
                  </h6>
                  <p>Acknowledment</p>
                  <h6 className='flex items-center mt-4'><DocumentTextIcon className="h-4 w-4 me-1" aria-hidden="true" /> Assighnment.pdf</h6>
                  <div className='bg-[#eeeff0] py-4 px-6 mt-2 employee_handbookss'>
                    <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]'>
                      {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                      <HtmlToPdf
                        data={{
                          'employeeName': "Innive",
                          'employeeId': "Empoyee.name",
                          'schoolName': "Private School",
                          'dateFrom': moment().format("YYYY-DD-MM"),
                          'dateTo': moment().format("YYYY-DD-MM"),
                          'subjectName': "Marathi",
                          'staffAllocation': "Pune",
                          'accountCharged': "50 rs",
                          'fteUtilized': "Fte"
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-span-2 bg-white'>
            <div className='px-4 right_box'>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Employee Position</label>
                <div className="mt-2">
                  <InputText value="" id="username" placeholder="Hr" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" /></div>
              </div>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Work Location</label>
                <div className="mt-2">
                  <InputText value="" id="username" placeholder="United States" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" /></div>
              </div>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Date</label>
                <div className="mt-2">
                  <InputText value="" id="username" placeholder="03/19/2023" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" /></div>
              </div>
              <div className="flex align-items-start box-checks p-3 mt-3">
                <Checkbox inputId="checks1" name="" value="checks" onChange={e => setChecked(e.checked)} checked={checked} />
                <label htmlFor="checks1" className="ml-2 text-[1vw]">
                  I have received, read, understand and agree to abide by this Acceptable Use Agreement,
                  BP/AR 4040 - Employee Use Of Technology, and other applicable laws and district policies
                  and regulations governing the use of district technology. I understand that there is no
                  expectation of privacy when using district technology or when my personal electronic
                  devices use district technology. I further understand that any violation may result in
                  revocation of users privileges, disciplinary action, and/or appropriate legal action.
                  I hereby release the district and its personnel from any and all claims and damages
                  arising from my use of district technoloy or from the failure of any technology
                  protection measures employed by the district.</label>
              </div>
            </div>
            <div className="grow flex justify-end gap-3 mb-3 mt-3 px-4">
              <Link to="/" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]">Cancel</Link>
              <button className="custmBtn blue radius8 text-center">Acknowledge</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SixPeriodEmployee;
